import React from 'react';
import classes from './Checkbox.module.css';

const Checkbox = ({label,forType,status,onClick}) => {
  return (
    <div>
        <input className={classes['inp-cbx']} checked={status} id={forType} value="1" name="fooby[1][]" type="checkbox" style={{display: 'none'}} onClick={onClick} />
        <label className={classes.cbx} for={forType}><span>
            <svg width="12px" height="10px" viewbox="0 0 12 10">
                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
            </svg></span><span>{label}</span>
        </label>
    </div>
  )
}

export default Checkbox
